module.exports = __webpack_public_path__ + "img/2AA.6d7fe28d.jpg";